import { render } from "./UserAccount.vue?vue&type=template&id=a6a1d5e8&scoped=true"
import script from "./UserAccount.vue?vue&type=script&lang=js"
export * from "./UserAccount.vue?vue&type=script&lang=js"

import "./UserAccount.vue?vue&type=style&index=0&id=a6a1d5e8&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6a1d5e8"]])

export default __exports__